import { useEffect, useState } from "react";

// An open tab keeps running the build it loaded, so hosts never saw fixes until they
// happened to refresh. Compare the running bundle with the one index.html now points to
// and offer a one-tap refresh when they differ.
const bundleOf = (html) => (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/) || [])[0] || "";

export default function NewVersionBar() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const running = ([...document.scripts].map(s => s.src).find(s => /\/static\/js\/main\./.test(s)) || "")
      .replace(/^https?:\/\/[^/]+/, "");
    if (!running) return; // dev server: no hashed bundle to compare
    let stopped = false;
    const check = async () => {
      try {
        const res = await fetch("/", { cache: "no-store" });
        const live = bundleOf(await res.text());
        if (!stopped && live && live !== running) setStale(true);
      } catch { /* offline: try again next time */ }
    };
    const id = setInterval(check, 5 * 60 * 1000);
    const onVisible = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onVisible);
    check();
    return () => { stopped = true; clearInterval(id); document.removeEventListener("visibilitychange", onVisible); };
  }, []);

  if (!stale) return null;
  return (
    <div role="status" data-testid="new-version-bar"
      className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-3 bg-amber-400 px-4 py-2 text-sm font-semibold text-slate-900 shadow">
      <span>A new version of HostFolio is available.</span>
      <button type="button" onClick={() => window.location.reload()}
        className="min-h-[36px] rounded-lg bg-slate-900 px-3 text-white">Refresh</button>
    </div>
  );
}
